// authContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import AuthUtils from '../auth/auth_utils';

const AuthContext = createContext({ 
  token: null, 
  isAuthReady: false, 
  setToken: () => {}
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(AuthUtils.GetAuthToken());
  const [isAuthReady, setIsAuthReady] = useState(!!token);

  // Optionally, if token may be updated elsewhere, subscribe in an effect:
  useEffect(() => {
    if (token) {
      setIsAuthReady(true);
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, isAuthReady, setToken, setIsAuthReady }}>
      {children}
    </AuthContext.Provider>
  );
};
